// ----------------------------------------------------------------------------
// Section: Locations
// ----------------------------------------------------------------------------
//
// This is a section that displays location cards in a carousel
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import './_location.scss';



document.addEventListener('DOMContentLoaded', () => {
    const storeMap = document.querySelector('.store__map');
    if (!storeMap) { return; }
    const mapKey = storeMap.getAttribute('data-maps-key');

    // Pulled from Google Maps documentation
    // eslint-disable-next-line no-async-promise-executor
    (g=>{var h,a,k,p='The Google Maps JavaScript API',c='google',l='importLibrary',q='__ib__',m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement('script'));e.set('libraries',[...r]+'');for(k in g)e.set(k.replace(/[A-Z]/g,t=>'_'+t[0].toLowerCase()),g[k]);e.set('callback',c+'.maps.'+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+' could not load.'));a.nonce=m.querySelector('script[nonce]')?.nonce||'';m.head.append(a);}));d[l]?console.warn(p+' only loads once. Ignoring:',g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n));})({
        key: mapKey,
        v: 'weekly',
    // Use the 'v' parameter to indicate the version to use (weekly, beta, alpha, etc.).
    // Add other bootstrap parameters as needed, using camel case.
    });

    let map;

    async function initMap($element) {
        if (!$element) return;

        // eslint-disable-next-line no-undef
        const { Map } = await google.maps.importLibrary('maps');

        const [lat, lng] = $element.getAttribute('data-coordinates').split(',').map(parseFloat);

        map = new Map($element, {
            zoom: 10,
            center: { lat, lng },
        });

        // eslint-disable-next-line no-undef, no-unused-vars
        const marker = new google.maps.Marker({
            position: { lat, lng },
            map: map,
            icon: 'https://cdn.shopify.com/s/files/1/0604/9120/2756/files/pin.svg?v=1691771340'
        });
    }

    function init() {
        initMap(document.querySelector('.store__map'));
    }

    init();

});
